import { render, staticRenderFns } from "./ModifySoftwareForm.vue?vue&type=template&id=3271a9bf"
import script from "./ModifySoftwareForm.vue?vue&type=script&lang=js"
export * from "./ModifySoftwareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports